var _g, _path, _path2, _path3, _g2, _path4, _g3, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartupSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 453,
    height: 302,
    viewBox: "0 0 453 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 73.5,
    width: 166,
    height: 166,
    rx: 30,
    fill: "#171918"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 74.5,
    width: 164,
    height: 164,
    rx: 29,
    stroke: "#C8C8C8",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.363 129.618L147.066 130.692C145.534 135.893 133.9 185.238 132.959 189.229C132.744 189.835 131.319 193.66 128.686 193.66C124.333 193.66 122.372 187.138 122.372 187.111C121.673 184.605 119.12 183.174 116.676 183.89C114.23 184.605 112.833 187.22 113.531 189.725C114.929 194.678 119.711 203.1 128.714 203.1C136.506 203.1 140.644 196.027 141.826 191.844C141.854 191.761 141.88 191.678 141.88 191.623C146.207 173.266 154.698 137.46 155.88 133.416L156.203 132.288C157.143 128.985 160.018 118.94 163.754 118.94C167.032 118.94 167.598 124.692 167.598 124.83C167.813 127.416 169.988 129.343 172.543 129.15C175.068 128.958 176.976 126.673 176.789 124.086C176.412 119.05 173.187 109.5 163.756 109.5C153.113 109.5 149.243 123.094 147.363 129.618Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.262 129.618L132.965 130.692C131.433 135.893 119.798 185.238 118.857 189.229C118.642 189.835 117.218 193.66 114.585 193.66C110.231 193.66 108.27 187.138 108.27 187.111C107.571 184.605 105.018 183.174 102.574 183.89C100.128 184.605 98.7312 187.22 99.4298 189.725C100.827 194.678 105.61 203.1 114.612 203.1C122.405 203.1 126.543 196.027 127.725 191.844C127.752 191.761 127.779 191.678 127.779 191.623C132.105 173.266 140.596 137.46 141.779 133.416L142.101 132.288C143.042 128.985 145.916 118.94 149.653 118.94C152.931 118.94 153.496 124.692 153.496 124.83C153.711 127.416 155.886 129.343 158.441 129.15C160.967 128.958 162.875 126.673 162.687 124.086C162.31 119.05 159.086 109.5 149.655 109.5C139.012 109.5 135.142 123.094 133.262 129.618Z",
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.012 129.618L118.715 130.692C117.183 135.893 105.548 185.238 104.607 189.229C104.392 189.835 102.968 193.66 100.335 193.66C95.981 193.66 94.0201 187.138 94.0201 187.111C93.3215 184.605 90.7685 183.174 88.3239 183.89C85.8784 184.605 84.4812 187.22 85.1798 189.725C86.577 194.678 91.3596 203.1 100.362 203.1C108.155 203.1 112.293 196.027 113.475 191.844C113.502 191.761 113.529 191.678 113.529 191.623C117.855 173.266 126.346 137.46 127.529 133.416L127.851 132.288C128.792 128.985 131.666 118.94 135.403 118.94C138.681 118.94 139.246 124.692 139.246 124.83C139.461 127.416 141.636 129.343 144.191 129.15C146.717 128.958 148.625 126.673 148.437 124.086C148.06 119.05 144.836 109.5 135.405 109.5C124.762 109.5 120.892 123.094 119.012 129.618Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 73.5,
    width: 166,
    height: 166,
    rx: 30,
    fill: "#EC602F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 74.5,
    width: 164,
    height: 164,
    rx: 29,
    stroke: "#C8C8C8",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 300,
    y: 106,
    width: 100,
    height: 100
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M349.72 205.941C377.18 205.941 399.441 183.68 399.441 156.22C399.441 128.761 377.18 106.5 349.72 106.5C322.261 106.5 300 128.761 300 156.22C300 183.68 322.261 205.941 349.72 205.941Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.842 159.062C330.301 159.062 352.562 136.801 352.562 109.342C352.562 81.8817 330.301 59.6211 302.842 59.6211C275.382 59.6211 253.121 81.8817 253.121 109.342C253.121 136.801 275.382 159.062 302.842 159.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.842 252.82C330.301 252.82 352.562 230.559 352.562 203.099C352.562 175.64 330.301 153.379 302.842 153.379C275.382 153.379 253.121 175.64 253.121 203.099C253.121 230.559 275.382 252.82 302.842 252.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.599 159.062C424.059 159.062 446.32 136.801 446.32 109.342C446.32 81.8817 424.059 59.6211 396.599 59.6211C369.14 59.6211 346.879 81.8817 346.879 109.342C346.879 136.801 369.14 159.062 396.599 159.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.599 252.82C424.059 252.82 446.32 230.559 446.32 203.099C446.32 175.64 424.059 153.379 396.599 153.379C369.14 153.379 346.879 175.64 346.879 203.099C346.879 230.559 369.14 252.82 396.599 252.82Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124 73.5V68.4408C124 51.8722 110.569 38.4408 94 38.4408H32C15.4315 38.4408 2 25.0093 2 8.44079V0.5",
    stroke: "white",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M350 73.5L350 0.5",
    stroke: "#EC602F",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M350 301.5L350 239.5",
    stroke: "#EC602F",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M128 239.5V239.5C128 255.655 114.903 268.752 98.7479 268.752H37.7479C21.3186 268.752 8 282.071 8 298.5V298.5",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 28,
    y: 55.5,
    width: 206,
    height: 206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 247,
    y: 55.5,
    width: 206,
    height: 206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.376471 0 0 0 0 0.184314 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupSecondary);
export default __webpack_public_path__ + "static/media/startupSecondary.b11df344fbc1f00bdd3baae3c0305bb0.svg";
export { ForwardRef as ReactComponent };